<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router/dist/vue-router'
import { useStore } from 'vuex'

import RevisionChip from '@/components/revision/RevisionChip.vue'

const route = useRoute()
const store = useStore()

const currentProject = computed(() => store.state.project.currentProject)
const currentSchematisation = computed(() => store.state.stabSchematisation.currentItem)
const years = computed(() => store.state.years.items)

const currentYear = computed(() => {
  return years.value?.find((item) => currentSchematisation.value?.year === item.id)
})
const showDikeTrajectoryBreadcrumb = computed(() => {
  return route.params.id && currentProject.value?.id
})

const currentRouteName = computed(() => route.name)
</script>

<template>
  <v-breadcrumbs>
    <v-breadcrumbs-item>
      <router-link class="text-white toolbar-text" :to="{ name: 'project-index' }">
        Home
      </router-link>
    </v-breadcrumbs-item>
    <template v-if="showDikeTrajectoryBreadcrumb">
      <v-breadcrumbs-divider />
      <v-breadcrumbs-item>
        <router-link
          class="text-white toolbar-text"
          :to="{ name: 'dikeIndex-trajectory', params: { id: route.params.id } }"
        >
          Dike trajectory
        </router-link>
      </v-breadcrumbs-item>
      <template
        v-if="
          currentRouteName !== 'dikeIndex-trajectory' && currentRouteName !== 'schematisation-stage'
        "
      >
        <v-breadcrumbs-divider></v-breadcrumbs-divider>
        <v-breadcrumbs-item>
          {{ route.meta.title }}
        </v-breadcrumbs-item>
      </template>
    </template>

    <template v-if="currentSchematisation && currentRouteName === 'schematisation-stage'">
      <v-breadcrumbs-divider></v-breadcrumbs-divider>
      <div class="text-white toolbar-text">
        {{ currentSchematisation.name }}
        <v-chip size="small" label>{{ currentYear?.year }}</v-chip>
        <RevisionChip
          class="ml-1"
          :revision="currentSchematisation.stage_configuration_revision"
          icon="mdi-table"
        ></RevisionChip>
        <RevisionChip
          class="ml-1"
          :revision="currentSchematisation.soil_type_revision"
          icon="mdi-landslide"
        ></RevisionChip>
        <RevisionChip
          class="ml-1"
          :revision="currentSchematisation.water_line_rule_revision"
          icon="mdi-window-shutter-cog"
        ></RevisionChip>
      </div>
    </template>
  </v-breadcrumbs>
</template>

<style scoped>
.toolbar-text {
  font-size: 15px;
  text-decoration: none;
}
</style>
